import script from "./lxwm.vue?vue&type=script&setup=true&lang=js"
export * from "./lxwm.vue?vue&type=script&setup=true&lang=js"

import "./lxwm.vue?vue&type=style&index=0&id=21cca356&lang=less&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21cca356"]])

export default __exports__